import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, LifeBuoy } from 'lucide-react';

/**
 * /help — public placeholder (unauthenticated users can land here via email
 * links). Uses the same visual template as our protected coming-soon pages
 * (amber icon badge + warm copy) but ships its own lightweight header so it
 * doesn't rely on AppHeader's logged-in chrome.
 */
const Help = () => (
  <div className="min-h-screen bg-background flex flex-col" data-testid="help-placeholder">
    <header className="px-5 py-4">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900"
        data-testid="help-back-home"
      >
        <ArrowLeft className="h-4 w-4" />
        <span className="text-sm font-medium">Back to home</span>
      </Link>
    </header>
    <main className="flex-1 px-5 pb-12">
      <div className="max-w-md mx-auto text-center pt-6">
        <div className="mx-auto w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mb-5">
          <LifeBuoy className="h-8 w-8 text-amber-600" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-heading font-extrabold text-slate-900 leading-tight">
          Help &amp; FAQ is coming soon.
        </h1>
        <p className="mt-3 text-base text-slate-600 leading-relaxed">
          We're putting together walkthroughs and answers to common questions. Need something now?
          Email{' '}
          <a className="text-amber-600 hover:underline" href="mailto:hello@sturent.ca">
            hello@sturent.ca
          </a>
          .
        </p>
        <Link to="/">
          <Button className="btn-primary mt-6 h-11 px-6 text-base">Back home</Button>
        </Link>
      </div>
    </main>
  </div>
);

export default Help;
